module.exports = __webpack_public_path__ + "static/media/social-engagement.d180af18.svg";